var map = {
	"./MerloLogoLight.png": "066a",
	"./app.png": "ea62",
	"./apps.svg": "1dff",
	"./beyla.png": "3db3",
	"./choosePayment.jpg": "fb46",
	"./merlocode-textonly.png": "4c99",
	"./merloimage.png": "5a45",
	"./placeOrder.jpg": "8c0c",
	"./productEditor.jpg": "0aca",
	"./restaurant.jpg": "5187"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";